(function () {
  'use strict';

  function request(url, options) {
    var config = options || {};
    config.headers = Object.assign({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, config.headers || {});

    return fetch(url, config).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'Erreur panier');
        });
      }
      return response.json();
    });
  }

  function jsonEndpoint(url, fallback) {
    var target = url || fallback;
    if (target.indexOf('.js') !== -1) return target;
    var parts = target.split('?');
    return parts[0].replace(/\/$/, '') + '.js' + (parts[1] ? '?' + parts[1] : '');
  }

  function emit(name) {
    document.dispatchEvent(new CustomEvent(name));
  }

  function controlsFor(button) {
    var scope = button.closest('.quick, .card-atc');
    if (!scope) return null;
    return {
      scope: scope,
      add: scope.querySelector('[data-ky-card-add]'),
      qty: scope.querySelector('.qty'),
      count: scope.querySelector('.qty .n')
    };
  }

  function setBusy(controls, busy) {
    controls.scope.setAttribute('aria-busy', String(busy));
    controls.scope.querySelectorAll('button').forEach(function (button) {
      button.disabled = busy || (
        button.hasAttribute('data-ky-card-add') &&
        (!button.dataset.variantId || button.dataset.available !== 'true')
      );
    });
  }

  function showQuantity(controls, quantity) {
    controls.count.textContent = quantity;
    controls.add.hidden = quantity > 0;
    controls.qty.hidden = quantity <= 0;
  }

  function refreshCart(openDrawer) {
    emit('ky:cart:refresh');
    if (openDrawer) emit('ky:cart:open');
  }

  function add(button) {
    if (button.disabled || !button.dataset.variantId) return;
    var controls = controlsFor(button);
    if (!controls || controls.scope.getAttribute('aria-busy') === 'true') return;

    setBusy(controls, true);
    var addPromise = window.KYCart && typeof window.KYCart.add === 'function'
      ? window.KYCart.add(Number(button.dataset.variantId), 1, {}, Number(button.dataset.variantPrice || 0))
      : request(jsonEndpoint(window.routes && window.routes.cart_add_url, '/cart/add.js'), {
        method: 'POST',
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }]
        })
      }).then(function () {
        refreshCart(true);
      });

    addPromise.then(function () {
      showQuantity(controls, 1);
    }).catch(function (error) {
      console.error(error);
    }).finally(function () {
      setBusy(controls, false);
    });
  }

  function change(button) {
    var controls = controlsFor(button);
    if (!controls || controls.scope.getAttribute('aria-busy') === 'true') return;
    var quantity = Math.max(0, Number(controls.count.textContent) + Number(button.dataset.delta));
    var variantId = controls.add.dataset.variantId;
    if (!variantId) return;

    setBusy(controls, true);
    request(jsonEndpoint(window.routes && window.routes.cart_update_url, '/cart/update.js'), {
      method: 'POST',
      body: JSON.stringify({ updates: { [variantId]: quantity } })
    }).then(function () {
      showQuantity(controls, quantity);
      refreshCart(false);
    }).catch(function (error) {
      console.error(error);
    }).finally(function () {
      setBusy(controls, false);
    });
  }

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest('[data-ky-card-add]');
    var qtyButton = event.target.closest('[data-ky-card-qty]');
    if (!addButton && !qtyButton) return;

    event.preventDefault();
    event.stopPropagation();
    if (addButton) add(addButton);
    if (qtyButton) change(qtyButton);
  }, true);

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button && event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.target.closest('a, button, input, select, textarea, label, [data-ky-card-add], [data-ky-card-qty], .card-atc, .quick, .qty')) return;

    var card = event.target.closest('.pc-card');
    if (!card) return;
    var link = card.querySelector('.ky-card-link[href]');
    if (!link || !link.href) return;
    window.location.assign(link.href);
  });

  document.documentElement.dataset.kyCardsReady = 'true';
})();
